import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ReactModal from 'react-modal';
import firebase from 'firebase/app';

firebase.initializeApp({
    projectId: 'walkies-log',
    apiKey: process.env.sREACT_APP_FIREBASE_KEY
  });

ReactModal.setAppElement('#root');

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js